import React from 'react'
import Input from '../../../../../../../../../../../Control/Input';

export default function InputNumberID({value, handleValidationUser, handleSetValueName, className}) {

    const _handleChangeValue = (event) => {
      const { value } = event.target;
      handleSetValueName && handleSetValueName(value)
    }
  return (
    <Input
        inputType="TEXT"
        value={value}
        onChange={_handleChangeValue}
        placeholder="Số CMND hoặc CCCD"
        handleValidationUser={handleValidationUser}
        className={className}
    />
  )
}
